import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import SubmitVideo from "./pages/SubmitVideo";
import MyVideos from "./pages/MyVideos";
import Profile from "./pages/Profile";
import AvailableRequests from "./pages/AvailableRequests";
import ClaimedVideos from "./pages/ClaimedVideos";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!localStorage.getItem("token"));

  useEffect(() => {
    // Listen for cross-tab storage events
    const handleStorageChange = (e) => {
      if (e.key === "token") {
        setIsAuthenticated(!!e.newValue);
      }
    };
    window.addEventListener("storage", handleStorageChange);

    // Listen for custom event (same tab)
    const handleAuthChange = () => {
      setIsAuthenticated(!!localStorage.getItem("token"));
    };
    window.addEventListener("auth-change", handleAuthChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("auth-change", handleAuthChange);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} />
        <Route path="/submit" element={isAuthenticated ? <SubmitVideo /> : <Navigate to="/login" />} />
        <Route path="/my-videos" element={isAuthenticated ? <MyVideos /> : <Navigate to="/login" />} />
        <Route path="/profile" element={isAuthenticated ? <Profile /> : <Navigate to="/login" />} />
        <Route path="/available-requests" element={isAuthenticated ? <AvailableRequests /> : <Navigate to="/login" />} />
        <Route path="/my-claims" element={isAuthenticated ? <ClaimedVideos /> : <Navigate to="/login" />} />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;